export default {
  // common
  ok: 'ตกลง',
  cancel: 'ยกเลิก',
  send: 'ส่ง',
  // time
  timeJustNow: 'เมื่อสักครู่',
  timeMinutesAgo: '{n} นาทีที่แล้ว',
  timeHoursAgo: '{n} ชม.ที่แล้ว',
  timeYesterday: 'เมื่อวาน',
  // chat toolbar titles
  chatEmotion: 'อีโมจิ',
  chatSendImage: 'ส่งรูปภาพ',
  chatSendFile: 'ส่งไฟล์',
  chatReceipt: 'ข้อความแจ้งอ่าน',
  chatSendVoice: 'ส่งข้อความเสียง',
  chatGroupInfo: 'ข้อมูลกลุ่ม',
  // chat area
  chatSomeoneAtMe: 'มีคนกล่าวถึงฉัน',
  chatNewMessages: 'ข้อความใหม่ {n} ข้อความ',
  chatBackToBottom: 'กลับไปด้านล่าง',
  chatReceiptPrefix: '[แจ้งอ่าน] ',
  // message actions / tips
  chatNoMoreMessages: 'ไม่มีข้อความเพิ่มเติม',
  chatDeleteConfirm: 'ลบข้อความนี้?',
  chatDeleteTitle: 'ลบข้อความ',
  chatRecallConfirm: 'ถอนข้อความนี้?',
  chatRecallTitle: 'ถอนข้อความ',
  chatRecalled: 'ถอนข้อความแล้ว',
  chatLocateFail: 'ไม่สามารถระบุตำแหน่งข้อความต้นฉบับได้',
  chatResendUnsupported: 'ข้อความนี้ไม่รองรับการส่งใหม่อัตโนมัติ กรุณาส่งใหม่ด้วยตนเอง',
  // input disabled tips
  chatGroupDissolved: 'กลุ่มถูกยุบแล้ว',
  chatGroupQuit: 'คุณไม่ได้อยู่ในกลุ่มนี้แล้ว',
  chatGroupBanned: 'กลุ่มถูกระงับแล้ว',
  chatUserBanned: 'บัญชีนี้ถูกระงับแล้ว',
  chatBanReason: ', เหตุผล: ',
  // message status / readed
  msgReaded: 'อ่านแล้ว',
  msgUnread: 'ยังไม่อ่าน',
  msgAllReaded: 'อ่านทั้งหมดแล้ว',
  msgSomeReaded: 'อ่านแล้ว {n} คน',
  msgSending: 'กำลังส่ง',
  msgSendFail: 'ส่งล้มเหลว',
  msgRecall: 'ส่งอีกครั้ง',
  msgMenuDelete: 'ลบ',
  msgMenuRecall: 'ถอน',
  // voice record
  recordTitle: 'บันทึกเสียง',
  recordDuration: 'ระยะเวลา',
  recordStart: 'เริ่ม',
  recordPause: 'หยุดชั่วคราว',
  recordResume: 'ดำเนินการต่อ',
  recordStop: 'หยุด',
  recordPlay: 'เล่น',
  recordStopPlay: 'หยุดเล่น',
  recordRestart: 'บันทึกใหม่',
  recordSend: 'ส่งเลย',
  recordStateReady: 'ยังไม่เริ่ม',
  recordStateRunning: 'กำลังบันทึก...',
  recordStatePaused: 'หยุดบันทึกชั่วคราว',
  recordStateStopped: 'หยุดบันทึกแล้ว',
  msgReadedTab: 'อ่านแล้ว ({n})',
  msgUnreadTab: 'ยังไม่อ่าน ({n})',
  // language
  langLabel: 'ภาษา',
  langZh: '中文',
  langEn: 'English'
}
